{
    "UsersByExtensions_ModalTitle": "Utenti",
    "UsersByExtensions_Filters": "Filtri",
    "UsersByExtensions_AllPartitions": "Tutti i siti",
    "UsersByExtensions_Header_Users": "Estensione - Nome completo",
    "UsersByExtensions_Header_MS_Licences": "Licenze MS",
    "UsersByExtensions_UserFields_Email": "Email",
    "UsersByExtensions_UserFields_Type": "Abbonamento CXA",
    "UsersByExtensions_UserFields_UseEmailAsUser": "Utilizzare l'e-mail come nome utente",
    "UsersByExtensions_Username_Display_Title": "Nome utente",
    "UsersByExtensions_Username_Display_Title_No_Username": "Nessun nome utente\n(Non è possibile creare questo utente)",
    "UsersByExtensions_UserFields_LegacyAppend": "(eredità)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Lite",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "UNO",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Presenza",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Creare\/Aggiornare un utente",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Elimina utente",
    "UsersByExtension_UserType_NONE": "Monitoraggio disattivato (senza licenza)",
    "UsersByExtension_UserType_ESSENTIALS": "Elementi essenziali",
    "UsersByExtension_UserType_ESSENTIALS_MST": "Standard CXA",
    "UsersByExtension_UserType_PROFESSIONAL": "Professionale",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA Premium",
    "UsersByExtension_UserType_ENTERPRISE": "Impresa",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA Advanced (storico)",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Agente di call center",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXA Premium",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Supervisore del call center",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXA avanzato",
    "UsersByExtension_UserType_IsNotAgent": "Questo utente ha un agente, se gli si concede questa Sottoscrizione, l'attività dell'agente non sarà più monitorata.",
    "UsersByExtension_UserType_IsNone": "L'estensione associata a questo utente non sarà più monitorata se gli si concede questa sottoscrizione.",
    "UsersByExtension_Users_Multiple_Errors": "Ci sono più utenti assegnati a questo interno: {}",
    "UsersByExtensions_ConfirmUserDelete": "Fare nuovamente clic per confermare che si desidera rimuovere l'accesso ai rapporti?",
    "UserByExtension_LicenceTypes_EV": "Licenza EV",
    "UserByExtension_LicenceTypes_None": "Utenti delle squadre",
    "LicenceSummary_Title": "Riassunto della licenza",
    "LicenceSummary_Headers_Type": "Tipo",
    "LicenceSummary_Headers_InUse": "In uso",
    "LicenceSummary_Types_Essentials": "Elementi essenziali",
    "LicenceSummary_Types_Essentials_MST": "Standard CXA",
    "LicenceSummary_Types_Professional": "Professionale",
    "LicenceSummary_Types_Professional_MST": "CXA Premium",
    "LicenceSummary_Types_Enterprise": "Impresa",
    "LicenceSummary_Types_Enterprise_MST": "CXA Advanced (storico)",
    "LicenceSummary_Types_Unlicenced": "Senza licenza",
    "AddAllUsers_Button_Title": "Creare utenti per tutte le estensioni non monitorate",
    "AddAllUsers_Button_Title_Interpolated": "Creare utenti {} per tutte le estensioni non monitorate",
    "NoUsersAdded": "Non sono stati aggiunti utenti",
    "TooManyUsers_NoLicences": "Impossibile aggiungere l'utente {} perché non ci sono licenze disponibili",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Non è possibile aggiungere {} utenti perché è disponibile solo la licenza {}.",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Impossibile aggiungere l'utente {} perché è disponibile solo la licenza {}.",
    "TooManyUsers_NoLicences_Plural": "Impossibile aggiungere utenti {} perché non ci sono licenze disponibili",
    "TooManyUsers": "Impossibile aggiungere l'utente {} perché sono disponibili solo licenze {}.",
    "TooManyUsers_Plural": "Impossibile aggiungere {} utenti perché sono disponibili solo {} licenze",
    "SuccessfullyAddedUsers": "Licenziati {} utenti con licenza \"{}\" con successo",
    "AddAllUsers_PromptMessage": "Creare utenti per tutte le estensioni non monitorate con licenza \"{}\".\n\nTutte le modifiche non salvate andranno perse, siete sicuri di voler continuare?\n\n",
    "AddAllUsers_Confirm": "Confermare",
    "AddAllUsers_Cancel": "Annullamento",
    "AddAllUsers_CreatingUsers": "Aggiunta di {} utenti con licenza \"{}\"...",
    "AddAllUsers_Loading": "Caricamento...",
    "NAME": "UsersByExtension",
    "UsersByExtensions_UserFields_CRM_Integration": "Integrazione CX",
    "UsersByExtension_CrmLicenceType_SOLO": "Integrazione Solo CRM",
    "UsersByExtension_CrmLicenceType_TEAMS": "Integrazione CRM di Teams",
    "UsersByExtension_CrmLicenceType_UNITE": "Integrazione CX",
    "UsersByExtension_CrmLicenceType_NONE": "Nessuna integrazione CRM",
    "LicenceSummary_Types_CallCentreAgent": "Agente del call center",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA Premium",
    "LicenceSummary_Types_CallCentreSupervisor": "Supervisore del call center",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA avanzato",
    "LicenceSummary_Types_CXIntegration": "Integrazione CX",
    "ProvisionAllCrm_Button_Title_Interpolated": "Crea\/aggiorna utenti con licenza {}",
    "ProvisionAllCrm_PromptMessage": "Crea utenti per tutte le estensioni non monitorate con {}. \n \n Tutte le modifiche non salvate andranno perse. Vuoi continuare? \n \n",
    "TooManyUsers_MaxTelSysCapReached": "Impossibile aggiungere l'utente {} poiché supererebbe il numero massimo di utenti consentiti dal sistema telefonico",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Non è possibile aggiungere {} utenti poiché ciò supererebbe il numero massimo di utenti consentito dal sistema telefonico",
    "UsersByExtensions_UserFields_CX_Integration": "Integrazione CX",
    "UsersByExtension_CxiLicenceType_SOLO": "Integrazione Solo CRM",
    "UsersByExtension_CxiLicenceType_TEAMS": "Integrazione CRM di Teams",
    "UsersByExtension_CxiLicenceType_CXI": "Integrazione CX",
    "UsersByExtension_CxiLicenceType_NONE": "Nessuna integrazione CRM",
    "ProvisionAllCxi_Button_Title_Interpolated": "Creare\/aggiornare gli utenti con {}",
    "ProvisionAllCxi_PromptMessage": "Crea utenti per tutte le estensioni non monitorate con l'integrazione CRM \"{}\". \n \n Tutte le modifiche non salvate andranno perse. Vuoi continuare? \n \n",
    "UsersByExtension_UserType_ESSENTIALS_WxC": "Utente WxC",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_WxC": "Agente WxC",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_WxC": "Supervisore WxC",
    "UsersByExtensions_UserFields_Welcome_Mail": "Invia email di benvenuto",
    "UsersByExtension_CxiLicenceType_CX_INTEGRATION": "Integrazione CX",
    "AddAllUsers_Send_Welcome_Email_Checkbox_Text": "Deseleziona se **non** vuoi inviare un'e-mail di benvenuto a tutti gli utenti.",
    "SendWelcomeEmailTitle": "Invia nuovamente l'email di benvenuto a \"{}\"",
    "SendWelcomeEmailConfirm": "Desideri inviare nuovamente l'email di benvenuto a \"{}\"?",
    "EmailSuccessMessage": "L'email è stata inviata correttamente a \"{}\"",
    "EmailFailMessage": "Si è verificato un errore imprevisto durante l'invio dell'e-mail. Riprova.",
    "UsersByExtensions_UserFields_RestoreBtn_Tooltip": "Ripristina utente",
    "UsersByExtensions_AllSecGroups": "[All]",
    "Telsys_MissingRoles_Day0": "Provisioning degradato. Si prega di abilitare l'autorizzazione di amministratore utente per l'utente di autenticazione TelSys.",
    "Telsys_MissingRoles_Day1": "Autorizzazione di amministratore utente non trovata per l'utente TelSys Auth. Procedere con cautela."
}